import React, {Component} from 'react';
import './NavbarDrawerButton.css'
export default class NavbarDrawerButton extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<button className="toggle_button" onClick={this.props.click}>
				<div className="toggle_button_line" />
				<div className="toggle_button_line" />
				<div className="toggle_button_line" />
			</button>
		)
	}
};
